import { useContext, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications'
import { IPostCapitalGood } from '../../../../shared/services/capital-good/capital-good.model'
import CapitalGoodService from '../../../../shared/services/capital-good/capital-good-service'
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container'
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading'
import { GoodForm } from '../../../presentation-components/organisation-components/good/good-form'
import { ScreenLabelsContext } from '../../../../context/screen-labels/screen-labels'

export const OrganisationGoodNewPage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  // The catalogue's "Sold products" empty state deep-links here preselecting the sold type.
  const preselectedTypeOfGood = searchParams.get('typeOfGood') === 'soldProduct' ? 'soldProduct' : 'purchasedGood'
  //Services
  const capitalGoodService = new CapitalGoodService()
  //Context
  const userNotificationsContext = useContext(UserNotificationsContext)
  const screenLabelsContext = useContext(ScreenLabelsContext)
  //State
  const [errorMessage, setErrorMessage] = useState<string | undefined>('')
  const [errorCode, setErrorCode] = useState<number>()
  const [newGood, setNewGood] = useState<IPostCapitalGood>({
    name: '',
    description: '',
    goodCategoryId: '',
    modelNumber: '',
    kgCarbonEmission: undefined,
    manufacturerId: null,
    manufacturerName: '',
    typeOfGood: preselectedTypeOfGood,
    unitType: 'caa84afc-0363-4d70-bd83-7ef33fde5df6',
    unitAmount: 1,
    capitalGoodReference: '',
    capitalGoodImageFilePath: '',
  })
  //Loading State
  const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false)
  const [factorChoice, setFactorChoice] = useState<string>('custom')

  //Component Event Handlers
  const onSubmit = async (formData: FormData) => {
    if (!isFormSubmitting) {
      setIsFormSubmitting(true)
      capitalGoodService.create(formData)
        .then(response => {
          setIsFormSubmitting(false)
          userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' })
          // EPD source: send them to the product page with the EPD dialog auto-opened ("save first, then attach").
          navigate(`/organisation/products/${response.id}${factorChoice === 'epd' ? '?openEpd=true' : ''}`)
        })
        .catch(err => {
          if (err.response.data.message) {
            setErrorMessage(err.response.data.message)
            setErrorCode(err.response.data.code)
          } else {
            userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          }
          console.log(err)
          setIsFormSubmitting(false)
        })
    } else {
      userNotificationsContext.openSnackbar({ open: true, message: 'Saving in progress, please wait' });
    }
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title={`Add New ${screenLabelsContext.getLabel('product', { capitalize: 'first' })}`}
        includeBackButton={true}
        backButtonLink={`/organisation/products`}
        backButtonText={`Back to ${screenLabelsContext.getLabel('product', { plural: true })}`}
      />
      <GoodForm
        newGood={newGood}
        onSubmit={onSubmit}
        isSubmitting={isFormSubmitting}
        errorMessage={errorMessage}
        errorCode={errorCode}
        onFactorSourceChange={setFactorChoice}
      />
    </PageOuterContainer >
  )
}